(function () {
  function initScrollAnimations() {
    var els = document.querySelectorAll('.animate-on-scroll');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initMobileMenu() {
    var toggles = document.querySelectorAll('[data-action="toggle-mobile-menu"]');
    var drawer = document.getElementById('mobile-menu-drawer');
    var overlay = document.getElementById('mobile-menu-overlay');
    if (!drawer) return;

    function close() {
      drawer.classList.add('hidden');
      drawer.setAttribute('hidden', '');
      if (overlay) {
        overlay.classList.add('hidden');
        overlay.setAttribute('hidden', '');
      }
      document.body.style.overflow = '';
    }

    function open() {
      drawer.classList.remove('hidden');
      drawer.removeAttribute('hidden');
      if (overlay) {
        overlay.classList.remove('hidden');
        overlay.removeAttribute('hidden');
      }
      document.body.style.overflow = 'hidden';
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (drawer.classList.contains('hidden') || drawer.hasAttribute('hidden')) open();
        else close();
      });
    });
    if (overlay) overlay.addEventListener('click', close);
  }

  function initComingSoon() {
    document.querySelectorAll('[data-coming-soon]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var existing = document.getElementById('elyfe-coming-soon');
        if (existing) existing.remove();

        var modal = document.createElement('div');
        modal.id = 'elyfe-coming-soon';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.innerHTML =
          '<div class="elyfe-coming-soon__backdrop"></div>' +
          '<div class="elyfe-coming-soon__card">' +
          '<p class="elyfe-coming-soon__eyebrow">Wellness Hub</p>' +
          '<h3 class="elyfe-coming-soon__title">Coming soon</h3>' +
          '<p class="elyfe-coming-soon__text">This article is on its way. Check back shortly for curated wellness reads.</p>' +
          '<button type="button" class="btn-primary elyfe-coming-soon__close">Got it</button>' +
          '</div>';
        document.body.appendChild(modal);

        function dismiss() { modal.remove(); }
        modal.querySelector('.elyfe-coming-soon__backdrop').addEventListener('click', dismiss);
        modal.querySelector('.elyfe-coming-soon__close').addEventListener('click', dismiss);
      });
    });
  }

  function initDragScroll() {
    document.querySelectorAll('[data-drag-scroll]').forEach(function (el) {
      var isDown = false, startX = 0, scrollLeft = 0;
      el.addEventListener('mousedown', function (e) {
        isDown = true; startX = e.pageX - el.offsetLeft; scrollLeft = el.scrollLeft;
      });
      el.addEventListener('mouseleave', function () { isDown = false; });
      el.addEventListener('mouseup', function () { isDown = false; });
      el.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        el.scrollLeft = scrollLeft - (e.pageX - el.offsetLeft - startX) * 2;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollAnimations();
    initMobileMenu();
    initDragScroll();
    initComingSoon();
  });
  document.addEventListener('shopify:section:load', function () {
    initScrollAnimations();
    initMobileMenu();
    initDragScroll();
    initComingSoon();
  });
})();
